import './SourceFilePicker.scss';
import { ReactNode } from 'react';
import { MdInsertDriveFile } from 'react-icons/md';
import {
  MAX_UPLOAD_BYTES_TEXT,
  PDF_CONTENT_TYPE
} from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';
import { FileDropZone } from '@Components/FileDropZone';
import { getSourceFileValidationError } from '../onboarding-api';

interface SelectedFileChipProps {
  name: string;
  caption: string;
  action?: ReactNode;
}

export const SelectedFileChip = ({ name, caption, action }: SelectedFileChipProps) => (
  <div className='selected-file-chip'>
    <MdInsertDriveFile className='file-icon' />
    <div className='file-meta'>
      <div className='file-name'>{name}</div>
      <div className='file-caption'>{caption}</div>
    </div>
    {action && <div className='selected-file-chip-action'>{action}</div>}
  </div>
);

interface SourceFilePickerProps {
  selectedFile: File | null;
  onFile: (file: File) => void;
  onError: (message: string) => void;
}

export const SourceFilePicker = ({ selectedFile, onFile, onError }: SourceFilePickerProps) => (
  <>
    <FileDropZone
      accept={PDF_CONTENT_TYPE}
      getValidationError={getSourceFileValidationError}
      onFile={onFile}
      onError={onError}
      // TODO: list Doc, Slides, Sheet once supported.
      hintText={`Supports PDFs up to ${MAX_UPLOAD_BYTES_TEXT}`}
    />
    {selectedFile && <SelectedFileChip name={selectedFile.name} caption='Selected file' />}
  </>
);
